const getOtherScope = (state) => state.other.shared.emails

export const getRelatedPeople = (state) => {
	return getOtherScope(state).exists
}
